const styles = theme => ({
  plans: {
    padding: theme.spacing(2),
  },
  buttonAddPlan: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
})

export default styles
